// availity-reactstrap-validation
import UploadForm from "components/shared-components/UploadForm";
import {
  useAvatar,
  useProfile,
  useUpdateProfile,
  useUploadAvatar,
  useMyProfile
} from "hooks";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Media,
  Row,
  Spinner,
} from "reactstrap";
import avatar from "../../assets/images/users/avatar-default.png";
//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const UserProfile = props => {
  const { t, i18n } = useTranslation(["common"]);

  const navigate = useNavigate();

  const [avatarImage, setAvatarImage] = useState("");
  const [avatarPreview, setAvatarPreview] = useState(null);

  const onFetchAvatarSuccess = response => {
    setAvatarImage(response);
  };

  const onUpdateProfileSuccess = () => {
    //refetchProfile();
    onRemoveFile();
    navigate({ pathname: "/dashboard" });
  };

  const onUploadAvatarSuccess = response => {
    if (response?.data?.id) {
      setValue("isShowSaveButton", response.data.id, { shouldValidate: true });
    }
  };

  const {
    data: { data: profile },
    isFetching: isFetchingProfile,
    refetch: refetchProfile,
  } = useProfile();

  useAvatar(null, onFetchAvatarSuccess);

  const { mutate: uploadAvatar, data: avatarData } = useUploadAvatar(
    onUploadAvatarSuccess
  );

  const { mutate: updateProfile } = useUpdateProfile(onUpdateProfileSuccess);

  const {
    handleSubmit,
    formState: { errors, touchedFields },
    register,
    setValue,
    watch,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      isShowSaveButton: false,
    },
  });

  const watchShowSaveButton = watch("isShowSaveButton", false);

  const handleFiles = files => {
    if (files.length > 0) {
      setAvatarPreview(files[0]);
      const data = new FormData();
      data.append("file", files[0]);
      uploadAvatar(data);
    }
  };

  const onRemoveFile = res => {
    setValue("isShowSaveButton", false, { shouldValidate: true });
    setAvatarPreview(null);
  };

  const submitForm = submitData => {
    const { display_name } = submitData;

    const displayName = display_name || profile?.display_name;

    const avatarId = avatarData?.data?.id
      ? avatarData?.data?.id
      : profile?.ext_value?.avatar_id;

    updateProfile({ displayName, avatarId });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("profile.info")}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Profile" breadcrumbItem={t("profile.info")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isFetchingProfile ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <Media>
                      <div className="ms-3">
                        <img
                          src={
                            avatarPreview
                              ? avatarPreview.preview
                              : avatarImage
                              ? avatarImage
                              : avatar
                          }
                          alt="Avatar"
                          className="avatar-lg rounded-circle img-thumbnail"
                        />
                      </div>
                      <Media body className="align-self-center">
                        <div className="text-muted">
                          <h5>{profile?.display_name}</h5>
                          <p className="mb-1">{profile?.username}</p>
                          <p className="mb-0">
                            {t("profile.checker_date")}
                            {profile?.checker_date &&
                              Intl.DateTimeFormat("en-GB", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                              }).format(profile?.checker_date * 1000)}
                          </p>
                        </div>
                      </Media>
                    </Media>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">{t("profile.updateInfo")}</h4>
          <Card>
            <CardBody>
              <FormGroup className="mb-3">
                <Label htmlFor="avatar">{t("profile.avatar")}</Label>
                <UploadForm
                  removeFile={onRemoveFile}
                  multiple={false}
                  handleFiles={files => handleFiles(files)}
                  accept=".png, .jpg, .jpeg"
                ></UploadForm>
                <input
                  style={{ display: "none" }}
                  {...register("isShowSaveButton")}
                ></input>
              </FormGroup>
              <div className="mt-4">
                {watchShowSaveButton && (
                  <Button
                    type="button"
                    color="primary"
                    disabled={isFetchingProfile}
                    className="mb-2 me-2 btn-label"
                    onClick={() => {
                      handleSubmit(submitForm)();
                    }}
                  >
                    <i className="bx bx-save label-icon" />
                    {t("profile.btnUpdate")}
                  </Button>
                )}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
